const gprs = {
  moduleTitle: "أوامر GPRS",
  actions: {
    view: "عرض",
    create: "إنشاء",
  },
  permissions: {
    core: "النواة",
    gprsManagement: "إدارة جي بي آر إس",
    gprs: "جي بي آر إس",
  },
  status: {
    PENDING: "قيد الانتظار",
    SUCCESSFUL: "ناجح",
    FAILED: "فشل",
    TIMED_OUT: "انتهت المهلة",
  },
  failureReasons: {
    offline: "الجهاز غير متصل",
    failed: "رفض الجهاز الأمر",
    timeout: "لم يستجب الجهاز في الوقت المحدد",
    expired: "انتظر الأمر طويلًا قبل إرساله",
    unsupported: "الجهاز لا يدعم هذا الأمر",
    tracking_unavailable: "تعذر على خدمة التتبع استلام الأمر",
    not_sent: "تعذر إرسال الأمر",
    no_result: "فُقدت نتيجة الأمر",
  },
  seconds: "{{value}} ثانية",
  noResponse: "لم يتم استلام رد",
  list: {
    title: "أوامر GPRS",
    subtitle: "متابعة الأوامر المرسلة إلى الأجهزة والتحقق من نتيجة تنفيذها.",
    toolbar: {
      search: "بحث",
      searchPlaceholder: "بحث...",
      send: "إرسال أمر جديد",
    },
    filters: {
      filters: "الفلاتر",
      status: "حالة الأمر الصادر",
      all: "الكل",
      createdDate: "تاريخ الإنشاء",
      createdDatePlaceholder: "اختر نطاق تاريخ",
      clearDateRange: "مسح",
      nextMonth: "الشهر التالي",
      previousMonth: "الشهر السابق",
    },
    table: {
      company: "الشركة",
      deviceName: "اسم الجهاز",
      imei: "رقم IMEI",
      command: "الأمر",
      response: "الاستجابة والرد",
      executionTime: "وقت التنفيذ",
      status: "حالة الأمر الصادر",
      createdAt: "تاريخ الإنشاء",
      empty: "لا توجد أوامر GPRS.",
      error: "تعذر تحميل أوامر GPRS.",
      loading: "جارٍ تحميل أوامر GPRS",
      total: "إجمالي {{total}} GPRS",
      rowsPerPageLabel: "عدد الصفوف في الصفحة",
      nextPage: "الصفحة التالية",
      previousPage: "الصفحة السابقة",
      pagination: "عرض الصفوف",
      sortAscending: "فرز تصاعدي",
      sortDescending: "فرز تنازلي",
      actionMenu: "الإجراءات",
    },
  },
  detail: {
    title: "تفاصيل استجابة آخر مرسل",
    subtitle: "تكوين وتصدير حزم الأوامر المباشرة للمركبة",
    close: "إغلاق",
    company: "الشركة",
    deviceName: "اسم الجهاز",
    imei: "رقم IMEI",
    command: "الأمر",
    response: "الاستجابة والرد",
    executionTime: "وقت التنفيذ",
    status: "حالة الأمر الصادر",
    createdAt: "تاريخ الإنشاء",
  },
  send: {
    title: "إرسال أمر GPRS",
    subtitle: "تكوين وتصدير حزم الأوامر المباشرة للمركبة",
    close: "إغلاق",
    company: "الشركة",
    companyPlaceholder: "اختر شركة أو أكثر",
    companySearch: "ابحث عن شركة",
    companyEmpty: "لا توجد شركات.",
    imei: "رقم IMEI",
    imeiPlaceholder: "اختر جهازًا أو أكثر",
    imeiSearch: "ابحث برقم IMEI",
    imeiEmpty: "لا توجد أجهزة مطابقة.",
    selectCompanyFirst: "اختر الشركة أولًا لعرض أجهزتها.",
    presetNotFound: "لم يتم العثور على جهاز نشط برقم IMEI {{imei}}. اختر جهازًا.",
    allDevices: "الكل",
    allDevicesChip: "كل الأجهزة",
    noAsset: "بدون أصل",
    remove: "إزالة {{name}}",
    command: "الأمر",
    commandPlaceholder: "اختار او اكتب الأمر",
    commandSearch: "ابحث عن أمر",
    commandEmpty: "لا يوجد أمر تدعمه الأجهزة المختارة.",
    commandHint: "يمكن اختيار أمر من الأوامر الموجودة أو كتابة أمر جديد",
    supportedBy: "تدعمه {{count}} من الأجهزة المختارة",
    customCommandOption: "كتابة أمر جديد",
    customCommand: "نص الأمر",
    customCommandPlaceholder: "اكتب الأمر",
    parameters: "المعلمات (Parameters)",
    parametersPlaceholder: "تظهر عند اختيار أمر يحتاج معلمات",
    parametersHint: "تظهر المعلمات تلقائيًا عند اختيار الأمر",
    customParameters: "المعلمات (اختياري)",
    customParametersPlaceholder: "اكتب معلمات الأمر",
    customParametersHint: "تُرسل بعد الأمر مفصولة بمسافة",
    errors: {
      parameterRange: "أدخل قيمة بين {{min}} و {{max}}.",
      parameterLength: "أدخل من {{min}} إلى {{max}} حرفًا.",
      parameterFormat: "هذه القيمة ليست بالصيغة المطلوبة.",
      wholeNumber: "أدخل عددًا صحيحًا.",
      customText: "استخدم الحروف الإنجليزية والأرقام والرموز فقط، بحد أقصى {{max}} حرفًا.",
      commandUnsupported: "لا يدعم أي من الأجهزة المختارة هذا الأمر. اختر أمرًا آخر.",
      catalogFailed: "تعذر تحميل الأوامر. حاول مرة أخرى.",
    },
    cancel: "إلغاء",
    submit: "إرسال",
    success: "تم إرسال الأمر إلى {{count}} جهاز. تتحدث حالة كل جهاز عند استجابته.",
    partialSuccess: "تم إرسال الأمر إلى {{sent}} من {{total}} جهاز؛ فشل {{failed}}.",
  },
};

export default gprs;
